import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'


const style = {
  root: {
    width: '100%',
    maxWidth: 1166,
    margin: '0 auto',
  },
  fluid: {
    maxWidth: 'none',
  },
}


const Container = ({
  fluid,
  classes,
  children,
  className,
}) => (
  <div
    className={classNames(classes.root, className, {
      [classes.fluid]: fluid,
    })}
  >
    {children}
  </div>
)


Container.propTypes = {
  fluid: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}


export default withStyles(style)(Container)
